import I18n from "i18n-js";
import { makeImmutable } from "../core";
import { RArray } from "../collections";
import { equalPaymentChannelIds } from "../ordering";
const PAYMENT_MEDIUM_SEPARATOR = ".";
export class PSinglePaymentChannel {
    constructor(params) {
        this.kind = "SingleChannel";
        this.name = params.name;
        this.channelId = params.channelId;
        this.logoUrl = params.logoUrl;
        this.enabled = params.enabled;
        this.groupName = params.groupName;
        this.domainValue = { type: "channel", channelId: params.channelId };
        this.stringValue = [
            this.kind,
            params.channelId.tag,
            "contents" in params.channelId ? params.channelId.contents : "",
        ].join(PAYMENT_MEDIUM_SEPARATOR);
        makeImmutable(this);
    }
    isSelected(selected) {
        return equalMediumValues(this.domainValue, selected);
    }
}
export class PSinglePaymentMethod {
    constructor(params) {
        this.kind = "SingleMethod";
        this.name = params.name;
        this.method = params.method;
        this.domainValue = { type: "method", method: params.method };
        this.stringValue = [this.kind, params.method].join(PAYMENT_MEDIUM_SEPARATOR);
        makeImmutable(this);
    }
    isSelected(selected) {
        return equalMediumValues(this.domainValue, selected);
    }
}
export class POnlineChannelGroup {
    constructor(params) {
        this.kind = "OnlineGroup";
        this.domainValue = null;
        this.name = params.name;
        this.paymentChannels = params.paymentChannels
            .sorted((a) => (a.enabled ? -1 : 1))
            .map((channel) => new PSinglePaymentChannel({
            enabled: channel.enabled,
            channelId: channel.id,
            logoUrl: channel.logo,
            name: channel.name,
            groupName: params.name,
        }));
        this.stringValue = this.kind;
        makeImmutable(this);
    }
    isSelected(selected) {
        return this.paymentChannels.some((channel) => channel.isSelected(selected));
    }
    getChannel(domainValue) {
        return (this.paymentChannels.findWhere((channel) => channel.isSelected(domainValue)) || null);
    }
}
var P24;
(function (P24) {
    P24[P24["BLIK"] = 154] = "BLIK";
    P24[P24["CARDS"] = 241] = "CARDS";
    P24[P24["GOOGLE_PAY"] = 264] = "GOOGLE_PAY";
    P24[P24["APPLE_PAY_PL"] = 252] = "APPLE_PAY_PL";
    P24[P24["APPLE_PAY"] = 253] = "APPLE_PAY";
})(P24 || (P24 = {}));
function isAppleChannelId(id) {
    switch (id.tag) {
        case "P24Channel":
            return id.contents === P24.APPLE_PAY_PL || id.contents === P24.APPLE_PAY;
        case "StripeChannel":
            return false;
    }
}
function equalMediumValues(a, b) {
    if (a.type === "channel" && b.type === "channel") {
        return equalPaymentChannelIds(a.channelId, b.channelId);
    }
    if (a.type === "method" && b.type === "method") {
        return a.method === b.method;
    }
    return false;
}
export class PPaymentMediumGenerator {
    static group({ paymentChannels, paymentMethods, includeApplePay, }) {
        const remainingChannels = includeApplePay
            ? [...paymentChannels]
            : paymentChannels.filtered(({ id }) => !isAppleChannelId(id)).raw;
        const result = [];
        for (const featuredChannelId of PPaymentMediumGenerator.FeaturedChannels) {
            const featuredChannelIdx = remainingChannels.findIndex(({ id }) => equalPaymentChannelIds(id, featuredChannelId));
            if (featuredChannelIdx === -1) {
                continue;
            }
            const featuredChannel = remainingChannels.splice(featuredChannelIdx, 1)[0];
            result.push(new PSinglePaymentChannel({
                name: featuredChannel.name,
                channelId: featuredChannel.id,
                logoUrl: featuredChannel.logo,
                enabled: featuredChannel.enabled,
                groupName: null,
            }));
        }
        if (remainingChannels.length > 0 && paymentMethods.includes("Online")) {
            result.push(new POnlineChannelGroup({
                name: I18n.t("payment_method.online.label"),
                paymentChannels: new RArray(remainingChannels),
            }));
        }
        if (paymentMethods.includes("Cash")) {
            result.push(new PSinglePaymentMethod({
                name: I18n.t("payment_method.cash.label"),
                method: "Cash",
            }));
        }
        if (paymentMethods.includes("Card")) {
            result.push(new PSinglePaymentMethod({
                name: I18n.t("payment_method.card.label"),
                method: "Card",
            }));
        }
        return new RArray(result);
    }
}
PPaymentMediumGenerator.FeaturedChannels = [
    { tag: "StripeChannel" },
    { tag: "P24Channel", contents: P24.BLIK },
    { tag: "P24Channel", contents: P24.GOOGLE_PAY },
    { tag: "P24Channel", contents: P24.APPLE_PAY_PL },
    { tag: "P24Channel", contents: P24.APPLE_PAY },
    { tag: "P24Channel", contents: P24.CARDS },
];
